// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__1J5nM","content":"GlobalSearch_content__3ODtS"};